// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"StlAppointment_gridContainer__2yCrR","containerClinic":"StlAppointment_containerClinic__3UapS"};